var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { cssClassMap } from '../../constants/SportCssMap';
var messages = defineMessages({
    stake_state_1: {
        id: 'stake_state_1',
        defaultMessage: 'Активна'
    },
    stake_state_2: {
        id: 'stake_state_2',
        defaultMessage: 'Выигрыш'
    },
    stake_state_3: {
        id: 'stake_state_3',
        defaultMessage: 'Проигрыш'
    },
    stake_state_4: {
        id: 'stake_state_4',
        defaultMessage: 'Возврат'
    },
    stake_state_5: {
        id: 'stake_state_5',
        defaultMessage: 'Продана'
    },
    stake_state_10: {
        id: 'stake_state_10',
        defaultMessage: 'Возврат'
    },
    stake_state_0: {
        id: 'stake_state_0',
        defaultMessage: 'Неизвестна'
    },
});
var ComplexInnerItem = function (props) {
    var factor = props.factor;
    var singleStatus = factor.FactorState;
    var eventName = factor.EventNotice ? factor.EventName + ' (' + factor.EventNotice + ')' : factor.EventName;
    var sportCssName = cssClassMap[factor.SportClassId];
    return (_jsxs("div", __assign({ className: 'history__bet__row history__bet__inner-item' }, { children: [_jsx("img", { src: require("../../assets/img/icons/".concat(sportCssName, ".svg")), alt: '' }), _jsxs("div", __assign({ className: 'history__bet__body__left history__bet__inner-item__name' }, { children: [_jsx("strong", { children: factor.FullDescription }), factor.IsLive && _jsx("span", __assign({ className: 'live' }, { children: "Live" })), _jsxs("div", { children: [factor.LeagueName, " ", eventName, ". ", moment(factor.StartDate).format('DD.MM.YYYY, HH:mm')] })] })), _jsxs("div", __assign({ className: 'history__bet__body__right history__bet__inner-item__rate' }, { children: [factor.FactorValue, _jsx("strong", { children: _jsx(FormattedMessage, __assign({}, messages['stake_state_' + singleStatus])) })] }))] })));
};
ComplexInnerItem.propTypes = {
    factor: PropTypes.object.isRequired
};
export default ComplexInnerItem;



// WEBPACK FOOTER //
// ./src/components/betting-history/ComplexInnerItem.jsx